var React = require('react');

function Guides (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"#FF9500","fillRule":"evenodd","d":"M16.705 24.487v4.502L0 20.726v-4.502l16.705 8.263zm0-6.113v4.502L0 14.615v-4.502l16.705 8.26zm0-6.11v4.501L0 8.502V4l16.705 8.263z","clipRule":"evenodd","key":0}),React.createElement("path",{"fill":"#fff","fillRule":"evenodd","d":"M23.207 26.771l-4.502 2.227V12.272l4.502-2.237V26.77zm6.113-3.027l-4.502 2.238V9.248l4.497-2.224.005 16.719zm1.609-.797V6.227L35.442 4v16.726l-4.513 2.221z","clipRule":"evenodd","key":1})]);
}

Guides.defaultProps = {"fill":"none","viewBox":"0 -2 36 36"};

module.exports = Guides;

Guides.default = Guides;
